app.controller("SelectionSessionsController", [
    "$scope", "Socket", "Selection", "Session", "$stateParams", "$uibModal", "StaticData", "ConfirmModal", "$state", "usSpinnerService", "toastr",
    function ($scope, Socket, Selection, Session, $stateParams, $uibModal, StaticData, ConfirmModal, $state, usSpinnerService, toastr) {

        StaticData.getItemsByKey("days").then(function (days) {
            $scope.days = days;
            $scope.daysMap = _.keyBy($scope.days, '_id');
        });

        StaticData.getItemsByKey("buildings").then(function (buildings) {
            $scope.buildings = [{name: "კორპუსი"}].concat(buildings);
            $scope.buildingsMap = _.keyBy($scope.buildings, '_id');
        });

        StaticData.getItemsByKey("session_types").then(function (sessionTypes) {
            $scope.sessionTypes = sessionTypes;
            $scope.sessionTypesMap = _.keyBy($scope.sessionTypes, '_id');
        });

        var fetchActivation = function (cb) {
            Selection.getActivation($stateParams.activationId).then(function (activation) {
                $scope.activation = activation;
            });
            Session.list($stateParams.activationId).then(function (sessions) {
                for (var i in sessions) {
                    var s = sessions[i];
                    var start = new Date(s.startTime);
                    s.endTime = new Date(start.getTime() + s.duration * 3600 * 1000);
                    s.day = $scope.days.filter(function (day) {
                        return day.id === s.dayOfWeek
                    })[0];
                }
                $scope.lectures = sessions.filter(function (s) {
                    return s.sessionType === 'lecture'
                });
                $scope.seminars = sessions.filter(function (s) {
                    return s.sessionType === 'seminar'
                });
                cb();
            });
        };

        var getSessionGroups = function () {
            usSpinnerService.spin("root");
            Session.groupList($stateParams.activationId).then(function (data) {
                $scope.groups = data;
                data.forEach(function (group) {
                    group.sessions.forEach(function (session) {
                        var time = new Date(session.startTime);
                        session.startTime = time.getTime()
                    })
                });
            });
            fetchActivation(function () {
                usSpinnerService.stop("root");
            });
        };

        $scope.add = function () {
            $uibModal.open({
                controller: "AddSessionController",
                templateUrl: _pb + 'admin/selection/add-session.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    activation: function () {
                        return $scope.activation
                    }
                }
            }).result
                .then(function () {
                    getSessionGroups();
                }, function () {
                });
        };

        $scope.edit = function (group, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            $uibModal.open({
                controller: "EditSessionController",
                templateUrl: _pb + 'admin/selection/edit-session.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            group: group
                        };
                    }
                }
            }).result
                .then(function () {
                    getSessionGroups();
                }, function (err) {
                    if (err) console.log('ERROR', err)
                })
        };

        $scope.move = function (group, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            $uibModal.open({
                controller: "MoveSessionGroupsController",
                templateUrl: _pb + 'admin/selection/move-session-groups.html',
                size: "md",
                backdrop: 'static',
            }).result
                .then(function (result) {
                    Session.moveGroups({
                        subjectFrom: $scope.activation._id,
                        subjectTo: result._id
                    }).then(function () {
                        getSessionGroups();
                    }).catch(function (err) {
                        console.error(err);
                    })
                }, function (err) {
                    if (err) console.error('ERROR', err)
                })
        };

        $scope.removeGroup = function (group, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            ConfirmModal.show({
                title: "ჯგუფის წაშლა",
                message: "გსურთ ამ ჯგუფის წაშლა?"
            }).result.then(function () {
                Session.remove(group._id).then(getSessionGroups());
            });
        };

        $scope.students = function (group, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $state.go("admin.selection-details", {activationId: $scope.activation._id, group: group._id});
        };

        $scope.showLecturerStatus = function (subject, group, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "AddMessageContainer",
                templateUrl: _pb + 'lecturer/add-message-container.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            subjectName: subject.name,
                            group: group,
                            sessionType: $scope.sessionTypesMap[group.sessionType].name,
                            type: 'view'
                        };
                    }
                }
            }).result
                .then(function () {
                    toastr.success('', 'სტატუსი განახლებულია');
                    $scope.loadPage();
                }, function () {
                });
        };

        $scope.updateTemplate = function() {
            ConfirmModal.show({
                title: "საგნის შაბლონის ასახვა მიმდინარე აქტივაციაზე",
                message: "გსურთ ამ აქტივაციაზე შაბლონის შეცვლა? ეს გამოიწვევს ქულების წაშლას"
            }).result.then(function () {
                Selection.updateActivationTemplate({subjectActivationId: $scope.activation._id}).then(function (res){
                    if(res.status === 'ok') {
                        toastr.success('', 'შაბლონი განახლებულია');
                        fetchActivation(() => {});
                    } else {
                        if (res.reason === 'NO_CURRENT_ACTIVATION'){
                            toastr.warning('', 'მიმდინარე სეზონში აქტივაცია არ მოიძებნა');
                        }
                        if (res.reason === 'SAME_TEMPLATE'){
                            toastr.warning('', 'მოცემული შაბლონი უკვე ასახულია');
                        }
                        if (res.reason === 'NO_TEMPLATE'){
                            toastr.warning('', 'საგანს არ აქვს შაბლონი');
                        }
                    }
                })
            });
        };

        $scope.goToURL = function (group) {
            window.open(group.zoomUrl);
        };

        $scope.goToArchiveURL = function (group) {
            window.open(group.archiveUrl);
        }

        getSessionGroups();
    }
]);
